"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuTitle = exports.MenuContainer = void 0;
exports.default = Menu;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _footerMenu = require("../../footer/footer-menu.js");
const MenuContainer = exports.MenuContainer = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "MenuContainer",
  class: "pl-m13a91nw"
});
const MenuTitle = exports.MenuTitle = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "MenuTitle",
  class: "pl-mzkjwyu"
});

/**
 * Menu component.
 * @module Menu
 *
 * @param {Object} props React props
 * @param {string} props.title Title Text
 * @param {node} props.children Menu list
 * @returns {React.ReactElement} Menu
 * @public
 */
function Menu({
  title,
  children
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(MenuTitle, null, title), /*#__PURE__*/_react.default.createElement(MenuContainer, null, children));
}
Menu.propTypes = {
  title: _propTypes.default.string,
  children: _propTypes.default.node
};